import Axios from "../../../../../api/axios/Axios";

export const getUserGroupPopThumbs = (groupTag, limit = 12, offset = 0) =>
  Axios.get(`/api/groups/${encodeURIComponent(groupTag)}/pops`, {
    params: {
      limit,
      offset,
    },
  });

export const getUserGroupPop = (groupTag, popTag) =>
  Axios.get(
    `/api/groups/${encodeURIComponent(groupTag)}/pops/${encodeURIComponent(popTag)}/play`,
  );
